import { FeApi } from '../../..';
import {
  type JobDetails,
  JobDetailsSchema,
} from '../../../domain/entities/capacity-evaluation';

export function jobDetailsMapper(
  data: FeApi.GetJobDetailsViewOutputRead,
): JobDetails {
  const result = JobDetailsSchema.safeParse({
    id: data.uuid,
    accureId: data.accure_id,
    status: data.status,
    createdAt: data.created_at,
    chargeStartTime: data.charge_start_time,
    chargeEndTime: data.charge_end_time,
    dischargeStartTime: data.discharge_start_time,
    dischargeEndTime: data.discharge_end_time,
    finishedAt: data.finished_at,
    createdBy: data.created_by,
  });

  if (result.success) {
    return result.data;
  } else {
    console.error('Failed to parse JobDetails:', result.error);
    const validFields = Object.fromEntries(
      Object.entries(result.error.flatten().fieldErrors).map(([key, value]) => [
        key,
        value?.[0] ?? undefined,
      ]),
    );

    const now = new Date();
    return JobDetailsSchema.parse({
      id: validFields.id ?? data.uuid ?? 'default-id',
      accureId: validFields.accureId ?? data.accure_id ?? '',
      status: validFields.status ?? data.status ?? 'Pending',
      createdAt: validFields.createdAt ?? data.created_at ?? now,
      chargeStartTime:
        validFields.chargeStartTime ?? data.charge_start_time ?? now,
      chargeEndTime: validFields.chargeEndTime ?? data.charge_end_time ?? now,
      dischargeStartTime:
        validFields.dischargeStartTime ?? data.discharge_start_time ?? now,
      dischargeEndTime:
        validFields.dischargeEndTime ?? data.discharge_end_time ?? now,
      finishedAt: validFields.finishedAt ?? data.finished_at ?? now,
      createdBy: validFields.createdBy ?? data.created_by ?? '',
    });
  }
}
